import PostSingle from "../../postAdmin/PostSingle";

const PostsCustomerDetail = ({ backPath = "/customer/posts" }) => {
  return <PostSingle back={backPath} />;
};
export default PostsCustomerDetail;
